<template>
    <section class="submittal-header">
        <div class="container">
            <nav class="breadcrumbs">
                <ul class="crumbs">
                    <li><a href="/">Home</a></li>
                    <li><a href="/submittal-manager">Submittal Manager</a></li>
                    <li>
                        <router-link :to="{ path: 'information' }" class="current">
                            Information
                        </router-link>
                    </li>
                    <li v-if="!showInformation">
                        <router-link :to="{ path: 'browse' }" class="current">
                            Browse
                        </router-link>
                    </li>

                    <li  v-if="!showInformation && !showBrowse">
                        <router-link :to="{ path: 'review' }" class="current">
                            Review
                        </router-link>
                    </li>
                    <li  v-if="!showInformation && !showBrowse && !showReview">
                        <router-link  :to="{ path: 'report' }" class="current">
                            Report
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>

        <information v-if="showInformation" :project="project"></information>
        <browse v-if="showBrowse" :project="project"></browse>
        <review v-if="showReview" :project="project"></review>
        <report v-if="showReport" :project="project"></report>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import information from 'vue/submittal-manager/mechanical/header/_information.vue';
    import browse from 'vue/submittal-manager/mechanical/header/_browse';
    import review from 'vue/submittal-manager/mechanical/header/_review';
    import report from 'vue/submittal-manager/mechanical/header/_report';

    export default {
        components: {
            information,
            browse,
            review,
            report
        },
        computed: {
            showInformation() {
                if (this.$route.name == 'new-mechanical-information' || this.$route.name == 'mechanical-information') {
                    return true;
                }
            },
            showBrowse() {
                if (this.$route.name == 'mechanical-browse') {
                    return true;
                }
            },
            showReview() {
                if (this.$route.name == 'mechanical-review') {
                    return true;
                }
            },
            showReport() {
                if (this.$route.name == 'mechanical-report') {
                    return true;
                }
            },

            ...mapGetters('mechanical', [
                'project'
            ])
        }
    }
</script>
